import React, { InputHTMLAttributes, forwardRef } from 'react';
import styles from '../css/customSearch.module.scss';

interface CustomTextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: string;
  onSearch?: ((value: string) => void) | undefined;
}

const CustomSearchInput = forwardRef<HTMLInputElement, CustomTextInputProps>(({ icon, onSearch, ...rest }, ref) => {
  return (
    <div className={styles.searchInputWrapper}>
      {icon && (
        <img
          src={icon}
          onClick={(e) => {
            if (onSearch) {
              const input = e.currentTarget.parentElement?.querySelector('input') as HTMLInputElement | null;
              onSearch(input?.value ?? '');
            }
          }}
          className={styles.searchIcon}
        />
      )}
      <input
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onSearch) {
            const input = e.currentTarget as HTMLInputElement;
            onSearch(input.value);
          }
        }}
        ref={ref}
        {...rest}
        type="text"
        className={styles.searchInput}
      />
    </div>
  );
});

CustomSearchInput.displayName = 'CustomSearchInput';

export default CustomSearchInput;
